module.exports = __webpack_public_path__ + "img/appstore.d926abb7.png";